<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">停车场基础信息</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-form-item
        label="停车场名称"
        prop="Name"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.Name"
          type="text"
          step="1"
          min="0"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写停车场名称"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="总停车位"
        prop="JsonExtend.TotalPlace"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.JsonExtend.TotalPlace"
          type="number"
          step="1"
          min="0"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写总停车位"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="所属单位"
        prop="BelongCompanyTypeId"
        style="display: inline-block"
      >
        <el-select
          v-model="ruleForm.BelongCompanyTypeId"
          placeholder="请选择"
          style="width: 50rem"
          :disabled="!IsEdit"
          @change="choceUnit"
        >
          <el-option>请选择</el-option>
          <el-option
            v-for="item in typeLevelDic"
            :key="item.ItemKey"
            :label="item.Extend1"
            :value="item.ItemKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 二级单位 -->
      <el-form-item label="" prop="OrgId" style="display: inline-block">
        <el-select
          v-model="ruleForm.OrgId"
          placeholder="请选择"
          style="width: 50rem"
          :disabled="!IsEdit"
        >
          <el-option>请选择</el-option>
          <el-option
            v-for="item in secondDic"
            :key="item.ItemKey"
            :label="item.Extend1"
            :value="item.ItemKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="联系人"
        prop="AdminName"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.AdminName"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写联系人"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="联系电话"
        prop="AdminPhone"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.AdminPhone"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写联系电话"
        ></el-input>
      </el-form-item>

      <el-form-item label="经度" prop="Longitude" style="display: inline-block">
        <el-input
          v-model="ruleForm.Longitude"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写经度"
        ></el-input>
      </el-form-item>
      <el-form-item label="纬度" prop="Latitude" style="display: inline-block">
        <el-input
          v-model="ruleForm.Latitude"
          style="width: 45rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写纬度"
        ></el-input>
      </el-form-item>

      <ZjLngLatSelect
        class="newtaskposition"
        :point_lat="ruleForm.Latitude"
        :point_lng="ruleForm.Longitude"
        @onGotLngLat="onGotLngLat"
      ></ZjLngLatSelect>
      <el-form-item
        label="所属区域"
        prop="BelongArea"
        style="display: inline-block"
      >
        <el-select
          v-model="ruleForm.BelongArea"
          placeholder="请选择"
          style="width: 50rem"
          :disabled="!IsEdit"
        >
          <el-option>请选择</el-option>
          <el-option
            v-for="item in EqRegionArr"
            :key="item.RegionId"
            :label="item.RegionName"
            :value="item.RegionId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="停车场地址"
        prop="Address"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.Address"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写停车场地址"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="停车场简介"
        prop="Introduction"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.Introduction"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写停车场简介"
        ></el-input>
      </el-form-item>
      <el-form-item label="停车场图片">
        <el-upload
          action="#"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :http-request="uploadAvatar"
          :before-upload="beforeAvatarUpload"
          :file-list="fileList"
          :disabled="!IsEdit"
        >
          <i class="addIcon"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-form-item>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import Apis from "../../../../../../api";
import ZJApp from "../../../../../app";
import waitAll from "../../../../../../utils/src/waitAll";
import areaApi from "../../../../../broadcast/src/apis"; //区域api
const utils = ZJApp.ZJUtils;
export default {
  name: "CompanyParkAdd",
  controller: "UI",
  action: "CompanyParkAdd",
  data() {
    return {
      typeLevelDic: [], //所属单位
      secondDic: [], //二级单位
      EqRegionArr: [], //所属区域
      CompanyChose: "",
      ruleForm: {
        JsonExtend: {
          ScenicName: "",
          ScenicId: "",
          TotalPlace: "",
          FileId: "",
          MalePlace:"",
          FemalePlace:"",
          NeutralPlace:""

        },
        // ID: '',
        Latitude: "",
        Longitude: "",
      },
      rules: {
        Name: [{ required: true, message: "请填写企业名称", trigger: "blur" }],
      },
      IsEdit: false,
      DeviceTypesArr: [],
      RegionData: [],
      imgList: [],
      fileList: [],
      delFileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      CompanyType: "停车场",
      chooseOrgId: "",
    };
  },
  created: function () {
    this.Status = parseFloat(this.$route.query.status);
    this.CompanyType = this.$route.query.CompanyType;
    if (this.$route.query.InfoId) {
      this.search();
      this.getFileList();
    }
    if (this.$route.query.type == "look") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    //区域
    this.getRegionInfo();
    // 所属单位
    this.basedatabind();
  },
  mounted: function () {},
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  methods: {
    //基础数据绑定 所属单位
    basedatabind() {
      this.loading = true;
      this.loadingText = "加载中...";
      utils
        .waitAll([this.config.getUValue("cyjc:cy", "")])
        .then((r) => {
          const eventlevelconf = r[0];
          this.typeOptions = eventlevelconf.JValue;
          for (let i = 0; i < this.typeOptions.length; i++) {
            let obj = {};
            let item = this.typeOptions[i];
            obj.ItemKey = item.ItemKey;
            obj.Extend1 = item.Extend1;
            this.typeLevelDic.push(obj);
          }
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 选择单位
    choceUnit(v) {
      console.log(v, 1);
      this.typeLevelDic.forEach((el) => {
        if (el.ItemKey == v) {
          this.CompanyChose = el.Extend1;
          this.chooseOrgId = el.ItemKey;
        }
      });
      if (this.CompanyChose == "全域") {
        this.getOrgData();
      } else {
        this.getSecondArea();
      }
    },
    //全域下的组织信息
    getOrgData() {
      let that = this;
      utils
        .waitAll([
          () => {
            return new Apis.OrgApi().FindByConditions({
              ParentOrgId: that.chooseOrgId,
            });
          },
        ])
        .then((r) => {
          //获取组织下的用户信息
          const optionsOrg = r[0].data.Data || [];
          that.secondDic = [];
          optionsOrg.forEach((el) => {
            let obj = {};
            obj.Extend1 = el.OrgName;
            obj.ItemKey = el.OrgId;
            that.secondDic.push(obj);
          });
        });
    },
    // 二级单位
    getSecondArea() {
      let that = this;
      let searchInfo = {
        CompanyType: this.CompanyChose,
        PageIndex: 1,
        PageSize: 100,
      };
      new MyApis.TbTourCompanyApi()
        .GetCompanyByType(searchInfo)
        .then((r) => {
          r = r.data.Data;
          that.secondDic = [];
          r.forEach((el) => {
            let obj = {};
            obj.Extend1 = el.Name;
            obj.ItemKey = el.OrgId;
            that.secondDic.push(obj);
          });

          console.log(this.secondDic, "数据回显");
          // that.ruleForm = r[0];
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 所属区域
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new areaApi.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      let that = this;
      if (file.FileUrl) {
        // 最后提交的时候再删除
        this.delFileList.push(file);
        this.fileList.forEach((item) => {
          if (item.FileUrl == file.FileUrl) {
            item.Validity = 0;
          }
        });
      }
      let arr = [];
      fileList.forEach((item) => {
        if (that.$route.query.type == "edit") {
          if (!item.FileUrl) {
            arr.push(item.raw);
          }
        } else {
          arr.push(item.raw);
        }
      });
      this.imgList = arr;
    },
    uploadAvatar(item) {
      this.imgList.push(item.file);
    },
    // 选取经纬度
    onGotLngLat(obj) {
      this.ruleForm.Latitude = obj.lat || 0;
      this.ruleForm.Longitude = obj.lng || 0;
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 查询数据
    search() {
      let InfoId = this.$route.query.InfoId;
      let that = this;
      if (InfoId) {
        let searchInfo = { ID: InfoId };
        new MyApis.TbTourCompanyApi()
          .GetCompanyByCondition(searchInfo)
          .then((r) => {
            r = r.data.Data;
            r.forEach((el) => {
              el.JsonExtend = JSON.parse(el.JsonExtend);
            });
            that.ruleForm = r[0];
            this.typeLevelDic.forEach((ele) => {
              if (ele.ItemKey == that.ruleForm.BelongCompanyTypeId) {
                that.CompanyChose = ele.Extend1;
              }
            });
            that.getSecondArea();
            console.log(this.typeLevelDic, "所属区域");
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //获取上传附件
    getFileList() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        const searchInfo = { AssocID: InfoId, PageSize: 100, PageIndex: 1 };
        this.data = this.$route.query.Info;
        this.loading = true;
        new Apis.FileApi()
          .GetFileList(searchInfo)
          .then((r) => {
            r = r.data.Data;
            this.fileList = r.FileList.map((item) => ({
              name: item.FileName,
              url: item.DownloadPath + "?d=1",
            }));
            console.log(this.fileList, "上传附件", r);
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //插入附件
    uploadAttch(feedid) {
      return new Promise((resolve, reject) => {
        let mediaList = this.imgList;
        var arr = [];
        mediaList.forEach((item) => {
          var option = {
            file: item,
            data: {
              module: "unifiedRelease", //模块名
              submodule: "Announcement", //子模块
              assocID: feedid, //业务ID
              uploader: ZJApp.ZJUser.current.UserName, //上传人
            },
            onProgress: () => {},
            onSuccess: () => {},
            onError: () => {},
          };
          arr.push(this.httpRequest(option));
        });

        waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    save() {
      let that = this;
      let uuid = ZJApp.ZJUtils.uuid();
      //先上传图片
      that.uploadAttch(uuid).then((r) => {
        // 图片assocID作为提交的ID
        if (this.$route.query.type == "edit") {
          this.ruleForm.ID = this.$route.query.InfoId;
        } else {
          this.ruleForm.ID = uuid;
        }
        that.saveData(r);
      });
    },
    saveData(r) {
      this.ruleForm.CompanyType = this.CompanyType;
      console.log(r, this.ruleForm);
      this.ruleForm.JsonExtend = JSON.stringify(this.ruleForm.JsonExtend);
      // 图片的infoID和信息的infoID一样
      // let uuid = "";
      // if (this.$route.query.type == "edit") {
      //   uuid = this.$route.query.InfoId;
      // } else {
      //   uuid = ZJApp.ZJUtils.uuid();
      // }

      // let InfoAttachmentDTOList = [];
      // let deptId =
      //   ZJApp.ZJUser.current.Departments.length > 0
      //     ? ZJApp.ZJUser.current.Departments[0].OrgId
      //     : "error-no-department";

      // console.log("this.ruleForm")
      // console.log(this.ruleForm)

      //如果有图片
      // if (r && r.length > 0) {
      //   r.forEach((item) => {
      //     // this.ruleForm.ID = item.AssocID;
      //     let obj = {
      //       assoid: item.AssocID,
      //       Id: item.ID,
      //       Validity: 1,
      //       // "Extend1":"",
      //       // "Extend2":"",
      //       // "Extend3":"",
      //       OrgId: deptId,
      //       // "AttachmenetId": ZJApp.ZJUtils.uuid(),
      //       InfoId: uuid,
      //       FileName: item.FileName,
      //       FileUrl: item.DownloadPath,
      //       FileType: item.Extension,
      //       FileId: item.FileID,
      //       Creater: item.Creater,
      //       CreateTime: item.CreateTime,
      //       Modifier: item.Modifier,
      //       ModifyTime: item.ModifyTime,
      //     };
      //     InfoAttachmentDTOList.push(obj);
      //   });
      // }

      // console.log(InfoAttachmentDTOList, "图片");
      // if (this.$route.query.type == "edit") {
      //     let arr = [];
      //     this.ruleForm.InfoAttachmentDTOList = arr.concat(
      //       this.fileList,
      //       InfoAttachmentDTOList
      //     );
      //   } else {
      //     this.ruleForm.InfoAttachmentDTOList = InfoAttachmentDTOList;
      //   }
      // console.log(this.ruleForm, "提交表单");
      if (this.$route.query.type == "edit") {
        //编辑
        this.Edit();
      } else {
        // 增加
        this.Add();
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
    //保存
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       this.loading = true;
    //       this.loadingText = "保存中...";
    //       if (this.$route.query.type == "add") {
    //         console.log(this.ruleForm);
    //         // this.Add();
    //       } else if (this.$route.query.type == "edit") {
    //         this.Edit();
    //       }
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    Add() {
      this.ruleForm.Validity = 1;
      this.ruleForm.CreateTime = new Date();
      this.ruleForm.Creater = ZJApp.ZJUser.current.UserName;
      this.ruleForm.ModifyTime = new Date();
      this.ruleForm.Modifier = ZJApp.ZJUser.current.UserName;
      // console.log(ZJApp.ZJUtils.uuid(), this.ruleForm, "提交表单121");
      new MyApis.TbTourCompanyApi()
        .AddItem(this.ruleForm)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.logInfo.ActionName = this.CompanyType+"基础信息添加";
          this.logInfo.LogMessage = r
            ? this.CompanyType+"基础信息添加成功"
            : this.CompanyType+"基础信息添加失败";
          this.logInfo.ModuleName = "产业基础信息";
          this.logInfo.PageName = this.CompanyType+"基础信息";
          this.addOperationLog();
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    Edit() {
      this.ruleForm.ModifyTime = new Date();
      this.ruleForm.Modifier = ZJApp.ZJUser.current.UserName;
      new MyApis.TbTourCompanyApi()
        .UpdateItem(this.ruleForm)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.logInfo.ActionName = this.CompanyType+"基础信息修改";
          this.logInfo.LogMessage = r
            ? this.CompanyType+"基础信息修改成功"
            : this.CompanyType+"基础信息修改失败";
          this.logInfo.ModuleName = "产业基础信息";
          this.logInfo.PageName = this.CompanyType+"基础信息";
          this.addOperationLog();
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
  },
};
</script>
<style type="text/css"></style>
